module.exports = "/assets/a7c7343d09db0ff881533c92fd9ecad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/D7.png
// module id = 2418
// module chunks = 0